import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormRecord } from '@angular/forms';
import { Filter } from '../../shared/models/filter.model';
import { FilterOption } from '../../shared/interfaces/filteroption.interface';
import { NgFor } from '@angular/common';
import { FilterCheckboxComponent } from './filterCheckbox/filter.checkbox.component';

@Component({
  selector: 'app-filter',
  templateUrl: 'filter.component.html',
  imports: [NgFor, FilterCheckboxComponent],
})
export class FilterComponent implements OnInit {
  // Pass data from parent to child with input binding
  @Input() filter: Filter = new Filter();
  @Input() form?: FormRecord<FormRecord<FormControl<boolean>>>;

  filterOptions: FilterOption[] = [];

  ngOnInit() {
    // Get the inital state for the filter options
    this.filterOptions = this.filter?.options;
  }
}
